import {QA, SectionDivider} from "src/components/v5/Faq/Faq";
import {useFaqIndex} from "src/hooks/useFaqIndex";

export const PHONE_NUMBERS = {
  REASON: "(415) 877-9821",
  MAIN: "1 833-440-2726",
};

const useInsurancePricingConstants = (): {
  faq: (QA | SectionDivider)[];
} => {
  const faq = useFaqIndex([
    "Do you accept my insurance?",
    "What are co-pays?",
    "What are deductibles?",
    "What does it mean if my insurance is not verified?",
    "Why is Carbon Health out-of-network with my plan?",
    "My plan has coverage for out-of-network services. Why do I have to pay up-front?",
    "I have questions about my bill. Who can I talk to?",
    "How does Carbon Health come up with their self-pay prices?",
    "Why do Carbon Health's self-pay prices vary by state?",
  ]);

  return {
    faq,
  };
};

export default useInsurancePricingConstants;
